import NestedCheckbox from '@shared/components/core/field/nested/NestedCheckboxes';
import SplashLoader from '@shared/components/loading/SplashLoader';
import { useScopes } from '@shared/hooks/useScopes';
import { useTranslation } from 'react-i18next';

interface IClientScopeEditorProps {
    value: string[];
    onUpdate: (field: 'authClientScopes', value: string[]) => void;
}

export default function ClientScopeEditor({ value, onUpdate }: IClientScopeEditorProps) {
    const { t } = useTranslation();
    const { scopes, loading, error } = useScopes();

    const handleStateChange = (updatedState: string[]) => {
        onUpdate('authClientScopes', updatedState);
    };

    if (!scopes || error || loading) return <SplashLoader />;
    return (
        <NestedCheckbox
            legend={t('common:organization.projects.scopes.manage')}
            options={scopes}
            activeValues={value}
            onUpdate={handleStateChange}
        />
    );
}
